function DefaultReturn(defaultReturn) {
    return function (target, propertyKey, descriptor) {
        // Запоминаем исходную функцию
        let originalMethod = descriptor.value;
        if (originalMethod) {
            // Подменяем ее на нашу обертку
            descriptor.value = function SafeWrapper() {
                let result = originalMethod.apply(this, arguments);
                if (result instanceof Error) {
                    return defaultReturn;
                }
                else {
                    return result;
                }
            };
        }
        return descriptor;
    };
}
export default DefaultReturn;
